const styles = theme => ({
  panelContainer: {
    // marginBottom: '24px',
    border: '0px !important',
    width: '100%',
    background: 'none',
  },
  titleHead: {
    background: 'transparent',
    color: theme.palette.primary.darksky100,
    display: 'flex',
    alignItems: 'center',
    padding: '0px',
    justifyContent: 'space-between',
    [theme.breakpoints.up('sm')]: {
      // borderBottom: '1px solid #CED1D6',
    },
    '& h1': {
      marginBottom: '0',
      marginRight: '8px',
      fontWeight: '600',
    },
  },
  greenChip: {
    background: 'transparent',
    fontSize: '14px',
    fontWeight: '500px',
    display: 'flex',
    gap: '8px',
    '&>span': { padding: '0px' },
    textTransform: 'lowercase',
    '& > span': {
      display: 'inline-block',
      '&::first-letter': {
        textTransform: 'uppercase',
      },
    },
    '&::before': {
      content: '""',
      width: '10px',
      height: '10px',
      borderRadius: '5px',
      background: '#138266',
    },
  },
  redChip: {
    background: 'transparent',
    fontSize: '14px',
    fontWeight: '500px',
    display: 'flex',
    gap: '8px',
    '&>span': { padding: '0px' },
    textTransform: 'lowercase',
    '& > span': {
      display: 'inline-block',
      '&::first-letter': {
        textTransform: 'uppercase',
      },
    },
    '&::before': {
      content: '""',
      width: '10px',
      height: '10px',
      borderRadius: '5px',
      background: '#B9350B',
    },
  },
  serviceDetail: {},
  title: {
    fontWeight: '600',
    marginBottom: '5px',
    fontSize: '16px',
  },
  requiredStar: {
    color: theme.palette.secondary.errorRed + '!important',
    marginLeft: '4px',
  },
  panelGridContainer: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
    gridTemplateRows: 'auto',
    columnGap: '10px',
    rowGap: '16px',
    alignItems: 'start',
    position: 'relative',
  },
  containerPadding: {
    padding: '16px',
  },

  containerBorder: {
    border: '1px solid #D5D6D7',
    background: theme.palette.primary.white,
  },

  // Accordion CSS
  accordionContainer: {
    [theme.breakpoints.up('md')]: {
      border: '0px solid #CED1D6',
      borderRadius: '10px !important',
    },
    margin: ' 0 0 5px !important',
    overflow: 'hidden',
    color: '#342D3D',
    '&:before': {
      background: 'transparent',
      display: 'none',
    },
  },
  expandedAccordion: {
    [theme.breakpoints.up('md')]: {
      borderRadius: '0px !important',
    },
  },
  accordionTitleHead: {
    background: 'transparent',
    color: '#342D3D',
    padding: '16px 0',
    boxShadow: 'none !important',
    // borderBottom: "1px solid #CED1D6",
    '& > div': {
      margin: '0 !important',
    },
    '& $accordionHeading': {
      fontSize: '16px',
      fontWeight: '600',
    },
    '& svg': {
      color: '#342D3D',
      fontSize: '27px',
    },
  },
  accordionHeading: {},
  accordionDetails: {
    padding: '0px',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  borderRadiusNone: {
    borderRadius: 0,
  },
  borderBottomNone: {
    borderBottom: 0,
  },
  // Information panel
  infoPanel: {
    marginBottom: '10px',
  },
  '@media (max-width: 767px)': {
    panelContainer: {
      marginBottom: '0px',
      borderRadius: '0px',
      border: '0px !important',
    },
    titleHead: {
      padding: '16px',
      flexWrap: 'wrap',
      borderRadius: '0',
    },

    // Accordion CSS
    accordionTitleHead: {
      minHeight: '48px !important',
      '& > div': {
        padding: '0',
      },
    },

    // Information panel
    infoPanel: {
      marginRight: '10px',
      marginLeft: '10px',
    },
  },
  '@media (min-width: 768px)': {
    titleHead: {
      padding: '16px 0px',
      '& h1': {
        fontSize: '18px',
        fontWeight: '600',
      },
    },
    containerPadding: {
      padding: '24px 24px 16px',
    },

    // Accordion CSS
    accordionContainer: {
      margin: '0 0 16px !important',
      boxShadow: 'none !important',
    },
    accordionTitleHead: {
      padding: '16px 0px',
      '& $accordionHeading': {
        fontSize: '18px',
      },
      '& svg': {
        fontSize: '27px',
      },
    },
  },
  '@media (max-width: 645px)': {
    panelGridContainer: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      rowGap: '10px',
      '& > div': {
        width: '100%',
      },
    },
  },
  titleHeadActions: {
    marginLeft: 'auto',
    display: 'flex',
    alignItems: 'center',
    '& button': {
      '& > span > p': {
        color: theme.palette.primary.main,
        fontWeight: 600,
        textTransform: 'none',
      },
    },
    '& > span': {
      margin: '0px 4px',
    },
  },
  // udpates for subtitle as sprint-26 register tenancy contract
  subTitle: {
    fontSize: '16px',
    fontWeight: '500',
    marginLeft: '5px',
    color: theme.palette.primary.darkGrey + '!important',
    [theme.breakpoints.down('sm')]: {
      fontSize: '14px',
      fontWeight: '500',
    },
  },
  backButton: {
    color: '#342D3D',
    border: '1px solid #130F26',
    textTransform: 'inherit',
    padding: '15px 20px',
    height: '40px',
    fontWeight: '500',
    fontSize: '16px',
    borderRadius: '0px',
    '&:hover': {
      border: 'none',
      background: theme.palette.primary.adgmHover, // Corrected "background" spelling
      color: theme.palette.primary.white,
      '& svg path': {
        // Removed colon for correct CSS targeting
        fill: theme.palette.primary.white,
      },
    },
    '&>span': {
      gap: '10px',
      '&>p': {
        fontWeight: '500',
      },
    },
  },
});

export default styles;
